<mat-selection-list [multiple]="false" #sprintpayFlexCreditBalance>
    <mat-list-option
        id="sprintpay-flex-option"
        [value]="sprintpayFlexCredit?.name"
        (click)="selectPaymentMethod()"
        [selected]="paymentMethodSelected === PaymentMethodsEnum.SPRINTPAY_FLEX"
        checkboxPosition="before"
        color="primary"
    >
        <div class="pe-3">
            <div class="d-flex flex-row align-items-center mb-2 rnpl-container">
                <app-lib-logo-payment-method
                    [paymentMethodName]="PaymentMethodsEnum.SPRINTPAY_FLEX"
                    [width]="'2.3em'"
                    [height]="'24px'"
                    class="me-3 border-0"
                />
                <div class="d-flex align-items-center rnpl-copy">
                    <div class="d-flex color-gray-80 rnpl-title">SprintPay Flex</div>
                    <app-rnpl-slogan></app-rnpl-slogan>
                </div>
            </div>
            <div class="d-flex">
                <p class="mb-0 color-gray-80 me-2">
                    Credit Available: {{ sprintpayFlexCredit?.balance?.avaliableCredit | currency }}
                </p>
                @if (!isEnoughCredit) {
                    <mat-icon class="warning-color" [matTooltip]="insufficientCreditWarning">info</mat-icon>
                }
            </div>
        </div>
    </mat-list-option>
</mat-selection-list>
